/**
 * Usonian CSS > Elements > Table
 */

import { css } from 'styled-components';
import { globals, colors } from 'shared/styles/settings';

export default css`
  table {
    width: 100%;
  }

  th {
    color: ${colors.grayLight} !important;
    font-size: ${globals.fontSizeSmall};
    text-align: left;
    text-transform: uppercase;
    font-weight: 700 !important;
    border-bottom-color: transparent !important;
    letter-spacing: 1.5px;
  }
  th:before{
    display:none;
  }
  tr{
    td {
      color: ${colors.midnightGrey};
      border-bottom-color: ${colors.grayLight2} !important;
    }
    &:last-child{
      td{
        border-bottom-color: transparent !important;
      }
    }
  }
`;
